import { Widget } from '@kanda-libs/ks-component-ts';

import AddIncomeItemButton from './AddIncomeItemButton';
import IncomeItem from './IncomeItem';

const Incomes: React.FunctionComponent = function () {
  return (
    <Widget.CreditFinanceDetailsIncomesArrayWrapper>
      {({ fields, arrayProps: { append, remove } }) => (
        <>
          {fields.map((field, index) => (
            <IncomeItem key={field.id} index={index} remove={remove} />
          ))}
          <AddIncomeItemButton append={append} />
        </>
      )}
    </Widget.CreditFinanceDetailsIncomesArrayWrapper>
  );
};

export default Incomes;
